/**
 * @file Team Carousel.
 */

import KeenSlider from 'keen-slider';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Team Carousel component.
 */
const vTeamCarousel = () => {
	const teamCarousel = document.querySelector('.v-team-carousel');

	if (!teamCarousel) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const team = teamCarousel.querySelectorAll('.v-team-carousel__item');

	const carousel = new KeenSlider(
		'.v-team-carousel__carousel',
		{
			loop:   true,
			slides: {
				perView: 5,
			},
			drag:        false,
			breakpoints: {
				'(min-width: 1025px)': {
					disabled: team.length <= 5,
				},
				'(max-width: 1024px)': {
					slides: {
						perView: 3,
					},
				},
				'(max-width: 900px)': {
					slides: {
						perView: 2,
					},
				},
				'(max-width: 615px)': {
					disabled: true,
				},
			},
		},
	);

	const arrowPrev = teamCarousel.querySelector('.v-team-carousel__button--previous');
	const arrowNext = teamCarousel.querySelector('.v-team-carousel__button--next');

	arrowPrev.addEventListener('click', () => carousel.prev());
	arrowNext.addEventListener('click', () => carousel.next());

	ScrollTrigger.matchMedia({
		'(min-width: 651px)': () => {
			gsap.to('.v-team-carousel__content', {
				'--clip':      '0%',
				ease:          'sine.out',
				scrollTrigger: {
					trigger: '.v-team-carousel__content',
					start:   'top bottom',
					end:     'bottom 75%',
					scrub:   true,
				},
			});
		},
	});
};

export default vTeamCarousel;
